// routes.js
import React from "react";
import Home from './Pages/Home.js';
import About from './Pages/Aboutus.js';
import Faq from './Pages/Faq.js';
import Terms from './Pages/Terms.js';
import OurTeam from './Pages/OurTeam.js';
import Career from './Pages/Careers.js';
import Contact from './Pages/Contact.js';
import NotFound from './Pages/NotFound.js';
import ChooseUs from './Pages/ChooseUs.js';
import PrivacyPolicy from './Pages/PrivacyPolicy.js';
import { Routes, Route } from "react-router-dom";
import Eligibility from "./Pages/Eligibilty.js";


// import About from './Pages/About.js';
// import OurMission from './Pages/Policy.js';

// import ChooseUs from './Pages/ChooseUs.js';
// import Proposals from './Pages/Proposals.js';
// import Paymentmethods from './Pages/Paymentmethods.js';
// import Register from './Pages/Register.js';
// import MatchedProfiles from './Pages/MatchedProfiles.js';
// import Terms from './Pages/Terms.js';
// import PrivacyPolicy from './Pages/PrivacyPolicy.js';

// import MatchResponse from './Pages/MatchResponse.js';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/about-us/" element={<About />} />
    
    {/*<Route path="/OurMission" element={<OurMission />} /> */}
    <Route path="/faq" element={<Faq />} />
    <Route path="/Ourteam" element={<OurTeam />} />
    {/* <Route path="/Ourteams" element={<OrgChart />} /> */}
    <Route path="/Contactus" element={<Contact />} /> 
    <Route path="/careers/" element={<Career />} /> 
    <Route path="/Why-Choose-Us" element={<ChooseUs />} />

    {/* More Link */}
    {/* <Route path="/Why-Choose-Us" element={<ChooseUs />} />
    <Route path="/Recentproposals" element={<Proposals />} />
    <Route path="/payment-methods" element={<Paymentmethods />} /> */}

    {/* Footer Links */}
    <Route path="/who-qualifies/" element={<Eligibility />} />
    <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
    <Route path="/terms" element={<Terms />} />

    {/* Always Glow Button */}

    
    {/* <Route path="/Registration" element={<Register />} />
    <Route path="/Profiles/:userId" element={<MatchedProfiles />} />
    <Route path="/match-response" element={<MatchResponse />} /> */}

    {/* Page 404 */}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
